import { render, staticRenderFns } from "./TopContentSelectOpDoc.vue?vue&type=template&id=ad036b8a&scoped=true&"
import script from "./TopContentSelectOpDoc.vue?vue&type=script&lang=ts&"
export * from "./TopContentSelectOpDoc.vue?vue&type=script&lang=ts&"
import style0 from "./TopContentSelectOpDoc.vue?vue&type=style&index=0&id=ad036b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad036b8a",
  null
  
)

export default component.exports